import { createContext, RefObject, useContext } from 'react';
import { UseFloatingReturn, UseInteractionsReturn } from '@floating-ui/react';

interface FloatingMenuContextType {
  context: UseFloatingReturn['context'];
  refs: UseFloatingReturn['refs'];
  getReferenceProps: UseInteractionsReturn['getReferenceProps'];
  getItemProps: UseInteractionsReturn['getItemProps'];
  activeIndex: number | null;
  listRef: RefObject<Array<HTMLButtonElement>>;
}

export const FloatingMenuContext = createContext<FloatingMenuContextType | null>(null);

export function useFloatingMenuContext() {
  const context = useContext(FloatingMenuContext);

  if (!context) {
    throw new Error('FloatingMenuContext not found');
  }

  return context;
}
